<template lang="html">
  <div class="pa-3">
    <v-layout row wrap pa-4 class="elevation-1 visao-geral">
      <v-flex xs12 class="box-title">
        <strong>Visão geral</strong>
      </v-flex>
      <v-flex xs6 sm6 md3 @click="pedidos" class="icone">
        <img src="../../../assets/vs-pedidos.png" alt="">
        <p>{{ countOrders }} pedidos</p>
      </v-flex>
      <v-flex xs6 sm6 md3 @click="itens" class="icone">
        <img src="../../../assets/vs-itens.png" alt="">
        <p>{{ countItens }} Itens</p>
      </v-flex>
      <v-flex xs6 sm6 md3 @click="avaliacoes" class="icone">
        <img src="../../../assets/vs-avaliacao.png" alt="">
        <p>{{ countRating }} Avaliações</p>
      </v-flex>
      <v-flex xs6 sm6 md3 @click="agendamento" class="icone">
        <img src="../../../assets/vs-agendamento.jpg" alt="">
        <p>{{ countSchedules }} Agendamentos</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'overview',
  computed: {
    countOrders () {
      return 0
    },
    countItens () {
      return 0
    },
    countRating () {
      return 0
    },
    countSchedules () {
      return 0
    }
  },
  methods: {
    pedidos () {
      this.$router.push('/Painel/Pedidos/Novos/')
    },
    itens () {
      this.$router.push('/Painel/Itens/Relacao/')
    },
    avaliacoes () {
      this.$router.push('/Painel/Atendimento/')
    },
    negocios () {
      this.$router.push('/Painel/Negocios/')
    },
    agendamento () {
      this.$router.push('/Painel/Agendamento/')
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// overview.vue?150dda12